var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(
        () => {
            _vm.isOpen = false;
        }
    ),expression:"\n        () => {\n            isOpen = false;\n        }\n    "}],staticClass:"hint"},[_c('div',{staticClass:"hint__icon text_9",on:{"click":function($event){_vm.isOpen = !_vm.isOpen}}},[_vm._v("?")]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.isOpen)?_c('div',{staticClass:"hint__text",domProps:{"innerHTML":_vm._s(_vm.hint)}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }